export default __webpack_public_path__ + "0ec6d85523970bca29541f45ae997cf4.svg";